import styles from '@/styles/tabbar.module.scss'
import { ReactNode } from 'react'

interface TabItem {
  id: number,
  name: string,
  itemWidth?: string; 
  reactNode?: ReactNode
}

interface props {
  activeTab: number;
  tabItemRightMargin?: string;
  tabList: TabItem[];
  onTabChange: (index: number) => void; // 从父组件传递的回调函数
  recordId?: (index: number | string) => void; // 记录当前的ID
}

export default function TabBar({ tabList, activeTab, tabItemRightMargin, onTabChange, recordId }: props) {
  // 点击切换tab
  const handleTabClick = (index: number, id: number | string) => {
    onTabChange(index) // 调用父组件传递的回调函数
    recordId && recordId(id)
  }
  
  return (
    <div className={styles['tab-box']}>
      <div className={styles['tab-list']}>
        {
          tabList.map((item: TabItem, index: number) => (
            <div 
              key={index}
              className={`${styles['tab-item']} ${index === activeTab ? styles['active'] : ''}`}
              style={{ 
                width: item.itemWidth ? item.itemWidth : 'auto',
                marginRight: tabItemRightMargin ? tabItemRightMargin : '60px',
               }}
              onClick={() => handleTabClick(index, item.id)}
            >
              {
                item.reactNode
                ?
                <>{item.reactNode}</>
                :
                <div className={styles['tab-name']}>{item.name}</div>
              }
              {
                (index === activeTab)
                &&
                <div className={styles['tab-active-instruct']}></div>
              }
            </div>
          ))
        }
      </div>
    </div>
  )
}
